import { CircleLoader } from '@components/ui';
import { useApi } from '@data-access';
import { CookieHelper } from '@helpers';
import { AppRoutes } from '@types';
import React, { useEffect, useState } from 'react';

export const LoginGuard = ({ children }: { children: React.ReactNode }) => {
  const { accounts } = useApi();

  const [loginStatus, setLoginStatus] = useState(false);

  const checkToken = async () => {
    try {
      const accessToken = CookieHelper.get('access_token');
      const refreshToken = CookieHelper.get('refresh_token');

      if (accessToken && refreshToken) {
        const response = await fetch(
          new URL(
            '/accounts/whoami/',
            process.env.NODE_ENV === 'development' ? process.env.NEXT_PUBLIC_API_BASE_PATH : window.location.origin,
          ),
          {
            method: 'GET',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              Authorization: `Bearer ${accessToken}`,
            },
            credentials: 'include',
          },
        );

        if (response.status === 200) {
          setLoginStatus(true);
          return;
        }

        const refreshResponse = await fetch(
          new URL(
            '/api-jwt-token/refresh/',
            process.env.NODE_ENV === 'development' ? process.env.NEXT_PUBLIC_API_BASE_PATH : window.location.origin,
          ),
          {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              Authorization: `Bearer ${accessToken}`,
            },
            body: JSON.stringify({ refresh: refreshToken }),
            credentials: 'include',
          },
        );

        if (refreshResponse.status === 200) {
          const { access: newAccessToken } = await refreshResponse.json();
          CookieHelper.set('access_token', newAccessToken);
          setLoginStatus(true);
          return;
        }

        if (refreshResponse.status === 401 || refreshResponse.status === 403) {
          window.location.replace(`/cal${AppRoutes.login}`);
          CookieHelper.remove('access_token');
          CookieHelper.remove('refresh_token');
        }
      }

      if (
        !window.location.pathname.startsWith('/cal/login') &&
        !window.location.pathname.startsWith('/cal/sso/callback')
      ) {
        window.location.replace(`/cal${AppRoutes.login}`);
      } else {
        setLoginStatus(true);
      }
    } catch (error) {
      window.location.replace(`/cal${AppRoutes.login}`);
    }
  };

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('mode') === 'read_only' && urlParams.get('token')) {
      setLoginStatus(true);
      return;
    }
    checkToken();
  }, [accounts]);

  if (!loginStatus) return <CircleLoader />;

  return <div>{children}</div>;
};
